export const RESOURCES_CAPACITY_UNIT_DICTIONARY_KEY = 'resources.capacity_unit'

export const RESOURCES_CAPACITY_UNIT_DEFAULTS: Array<{ value: string; label: string }> = [
  { value: 'spots', label: 'Spots' },
  { value: 'units', label: 'Units' },
  { value: 'quantity', label: 'Quantity' },
]
